import React from "react";
import { Outlet, useNavigate, Link, useLocation } from "react-router-dom";
import { Layout, Menu, Button, Typography } from "antd";
import {
  TeamOutlined,
  ApiOutlined,
  CalendarOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import { useAdminAuth } from "./AdminAuthContext";

const { Header, Sider, Content } = Layout;
const { Text } = Typography;

export default function AdminLayout() {
  const { user, signOut } = useAdminAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const selectedKey = location.pathname.includes("integrations")
    ? "integrations"
    : location.pathname.includes("events")
    ? "events"
    : "attendees";

  const handleLogout = async () => {
    await signOut();
    navigate("/admin/login", { replace: true });
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Header
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          background: "#fff",
          borderBottom: "1px solid #eaecef",
          padding: "0 1.5rem",
        }}
      >
        <Text strong style={{ fontSize: "1.1rem" }}>
          HANYC Admin
        </Text>
        <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
          <Text type="secondary">{user ? user.email : ""}</Text>
          <Button icon={<LogoutOutlined />} onClick={handleLogout}>
            Sign Out
          </Button>
        </div>
      </Header>
      <Layout>
        <Sider breakpoint="lg" collapsedWidth="0" theme="light">
          <Menu
            mode="inline"
            selectedKeys={[selectedKey]}
            style={{ height: "100%" }}
            items={[
              {
                key: "attendees",
                icon: <TeamOutlined />,
                label: <Link to="/admin/attendees">Attendees</Link>,
              },
              {
                key: "events",
                icon: <CalendarOutlined />,
                label: <Link to="/admin/events">Events</Link>,
              },
              {
                key: "integrations",
                icon: <ApiOutlined />,
                label: <Link to="/admin/integrations">Integrations</Link>,
              },
            ]}
          />
        </Sider>
        <Content style={{ padding: "1.5rem" }}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
}
